import { gql } from 'apollo-angular';

export default gql`
  mutation saveControl($control: ControlInput!) {
    saveControl(control: $control) {
      __typename
      ... on Control {
        uri
        name
        tenantUri
        field {
          uri
          name
          tenantUri
          fieldTypeUri
          version
          propertyValues {
            fieldUri
            fieldTypePropertyUri
            value
          }
        }
        controlTypeUri
        propertyValues {
          controlUri
          controlTypePropertyUri
          value
        }
        descendants {
          uri
          name
          parentControlUri
          controlTypeUri
          version
          sortOrder
          disabled
        }
        version
        createdOn
        createdByUri
        updatedOn
        updatedByUri
      }
      ... on ValidationResult {
        hasViolations
        violations {
          source
          providedValue
          description
          localisationResourceId
        }
      }
    }
  }
`;
